let collectionOfConfigs = [],
    initializedAndHistorySwiper = [],
    defaultSettings = {
        loop: true,
        speed: 700,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        autoplay: {
            delay: 5000,
            disableOnInteraction: false
        }
    };

function initSlider( collection ){

    collection.forEach( configAndAttrs => {
        if( !configAndAttrs[0] )
            return;
        
        configAndAttrs[1] = !configAndAttrs[1] ? defaultSettings : configAndAttrs[1] ;

        document.querySelectorAll(configAndAttrs[0]).forEach( (element, index) => {
            element.setAttribute(`data-swiper-${index}`,"");
            let swiper = new Swiper(`[data-swiper-${index}]`, configAndAttrs[1]);
            initializedAndHistorySwiper[index] = swiper;
        });
    } );

}

collectionOfConfigs.push([
    '.swiper-slider'
]);

collectionOfConfigs.push([
    '.js-teamSlider_swiper',
    {
        loop: true,
        speed: 700,
        slidesPerView: 1,
        centeredSlides: true,
        spaceBetween: 45,
        // autoplay: {
        //     delay: 5000,
        // },
        navigation: {
            prevEl: '.teamSlider_arrow-prev',
            nextEl: '.teamSlider_arrow-next',
        },
        breakpoints: {
            640: {
                slidesPerView: 1.57,
            }
        }
    }
]);

document.addEventListener('DOMContentLoaded', () => {
    initSlider(collectionOfConfigs);
});